import { render, staticRenderFns } from "./LaporanForm.vue?vue&type=template&id=61f807f9&"
import script from "./LaporanForm.vue?vue&type=script&lang=js&"
export * from "./LaporanForm.vue?vue&type=script&lang=js&"
import style0 from "./LaporanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports